import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Input.scss';

class Input extends Component {
  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    max: PropTypes.string,
    min: PropTypes.string,
    maxLength: PropTypes.string,
    minLength: PropTypes.string,
    onChange: PropTypes.func,
    step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    autoComplete: PropTypes.oneOf(['on', 'off']),
    hideSpinBox: PropTypes.bool,
    autoFocus: PropTypes.bool,
    passedRef: PropTypes.object,
    defaultValue: PropTypes.string
  };

  static defaultProps = {
    autoComplete: 'off'
  };

  render() {
    const className = this.props.hideSpinBox ? this.props.className + ' input__spin-box--hide' : this.props.className;

    const props = {
      ...this.props,
      className: className,
      ref: this.props.passedRef
    };
    return <input {...props} />;
  }
}

export default Input;
